import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'email'
})
export class EmailPipe implements PipeTransform {
    transform(email: string, option: string = 'short') {
        if (!email) {
            return '';
        }

        const end = email.indexOf('@');
        if (end >= 0 && option.toLowerCase() === 'short') {
            return email.slice(0, end).trim();
        }

        // Simply return the email as-is if the parameter was anything esle
        // or we couldn't find an @ character
        return email;
    }
}
